module.exports = __webpack_public_path__ + "static/media/Location.c26559b8.svg";